import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

const BLOCKS = [
  { key: "vision", label: "Vision", icon: "bi-eye" },
  { key: "mission", label: "Mission", icon: "bi-bullseye" },
  { key: "about", label: "About School", icon: "bi-info-circle" },
];

function ContentBlocksPage() {
  const [activeTab, setActiveTab] = useState("vision");
  const [blocks, setBlocks] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchAllBlocks();
  }, []);

  const fetchAllBlocks = async () => {
    try {
      const res = await axiosInstance.get("/api/content");
      const map = {};
      res.data.forEach((block) => {
        map[block.block_key] = block;
      });
      setBlocks(map);
    } catch (err) {
      toast.error("Failed to load content");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setBlocks((prev) => ({
      ...prev,
      [activeTab]: { ...prev[activeTab], [field]: value },
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const current = blocks[activeTab];
      const res = await axiosInstance.put(`/api/content/${activeTab}`, {
        title: current.title,
        body: current.body,
      });
      setBlocks((prev) => ({ ...prev, [activeTab]: res.data }));
      toast.success(`${BLOCKS.find((b) => b.key === activeTab).label} updated`);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  const current = blocks[activeTab] || {};

  return (
    <div>
      <h4 className="mb-4">Vision / Mission / About</h4>

      <div className="card border-0 shadow-sm">
        {/* Tabs */}
        <div className="card-header bg-white">
          <ul className="nav nav-tabs card-header-tabs">
            {BLOCKS.map((block) => (
              <li className="nav-item" key={block.key}>
                <button
                  className={`nav-link ${activeTab === block.key ? "active" : ""}`}
                  onClick={() => setActiveTab(block.key)}
                  type="button"
                >
                  <i className={`bi ${block.icon} me-1`}></i>
                  {block.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="card-body">
          <form onSubmit={handleSave}>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={current.title || ""}
                onChange={(e) => handleChange("title", e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Content</label>
              <textarea
                className="form-control"
                rows="8"
                value={current.body || ""}
                onChange={(e) => handleChange("body", e.target.value)}
                required
              ></textarea>
            </div>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContentBlocksPage;
